import { bindActionCreators } from 'redux';
import { isOneQuestionAtATime } from '../../../../selectors/quizSessions';
import { fileUploading } from '../../../../selectors/calls';
import { connect } from '../../../../react-redux';
import { SidebarItem as SidebarItemPresenter } from './presenter';
import { scrollToItem as scrollToItemAction } from '../../../../actions/scrolling';
import t from '@instructure/quiz-i18n/format-message';
export var mapStateToProps = function mapStateToProps(state, props) {
  var displayPosition = props.quizEntry ? props.quizEntry.positionToDisplay(props.position) : t('{position, number}', {
    position: props.position
  });
  return {
    displayPosition: displayPosition,
    preventScrollToItem: fileUploading(state) && isOneQuestionAtATime(state)
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    scrollToItem: props.scrollToItem || bindActionCreators(scrollToItemAction, dispatch)
  };
};
export var SidebarItem = connect(mapStateToProps, mapDispatchToProps)(SidebarItemPresenter);
export default SidebarItem;